import SvgIcon, { SvgIconProps } from "./SvgIcon";

const ColoredCampIcon: React.FC<SvgIconProps> = ({ variant, ...props }) => {
  return (
    <SvgIcon {...props}>
      {variant == "outlined" ? (
        <>
          <path
            d="M6 4C6 5.10457 5.10457 6 4 6C2.89543 6 2 5.10457 2 4C2 2.89543 2.89543 2 4 2C5.10457 2 6 2.89543 6 4Z"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            stroke="#262626"
          />
          <path
            d="M14 5L17 2L20 5"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            stroke="#25D846"
          />
          <path
            d="M14 10L17 7L20 10"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            stroke="#25D846"
          />
          <path
            d="M17 14V2"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            stroke="#25D846"
          />
          <path
            d="M17 14H7L2 22H22L17 14Z"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            stroke="#262626"
          />
          <path
            d="M8 14V22"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            stroke="#262626"
          />
          <path
            d="M9 14L14 22"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            stroke="#262626"
          />
        </>
      ) : (
        <>
          <path
            d="M4 6C5.10457 6 6 5.10457 6 4C6 2.89543 5.10457 2 4 2C2.89543 2 2 2.89543 2 4C2 5.10457 2.89543 6 4 6Z"
            fill="#262626"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            stroke="#262626"
          />
          <path
            d="M14 5L17 2L20 5"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            stroke="#25D846"
          />

          <path
            d="M14 10L17 7L20 10"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            stroke="#25D846"
          />
          <path
            d="M17 14V2"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            stroke="#25D846"
          />
          <path
            d="M17 14H7L2 22H22L17 14Z"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            stroke="#262626"
          />
          <path
            d="M8 14V22"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            stroke="#262626"
          />
          <path
            d="M9 14L14 22"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            stroke="#262626"
          />
          <path
            opacity="0.2"
            d="M14.5 22L10 14.5H17.5L21.5 22H14.5Z"
            fill="#25D846"
          />
        </>
      )}
    </SvgIcon>
  );
};

export default ColoredCampIcon;
